import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './user';
import quote from './quote';
import carSearch from './car-search';
import lead from './lead';
import application from './application';
import ui from './ui';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'ecx.novated',
  storage: window.localStorage,
  reducer: (state) => ({
    // Add fields that should be persisted
    carSearch: state.carSearch,
    finance: state.finance
  })
});
export default new Vuex.Store({
  modules: {
    application,
    carSearch,
    lead,
    quote,
    user,
    ui
  },
  plugins: [vuexLocal.plugin]
});
